/*

    ИТОГ ЧЕКА
*/


import './CheckItog.css';
import { useState, useEffect } from 'react'
import axios_sender from '../modules/axios_sender.js'
import unique from '../modules/unique.js';




function CheckItog(props) {
 
    const [animal_list, SetAnimalList] = useState([]);                      // список животных клиента

    //useEffect(() => { LoadAnimalsForClient(props.Client) }, [props.Client]);


  return (      

    <div></div>
  );


 

}

export default CheckItog;
